/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  UpdateAllNotificationPreferencesByKindMutationRequest,
  UpdateAllNotificationPreferencesByKindMutationResponse,
  UpdateAllNotificationPreferencesByKindPathParams,
  UpdateAllNotificationPreferencesByKind400,
} from '../types/UpdateAllNotificationPreferencesByKind'

function getUpdateAllNotificationPreferencesByKindUrl({
  kind_slug,
}: {
  kind_slug: UpdateAllNotificationPreferencesByKindPathParams['kind_slug']
}) {
  const res = {
    method: 'PATCH',
    url: `/api/v1/notifications/preferences/kind/${kind_slug}/` as const,
  }
  return res
}

/**
 * @summary Bulk-update email/in-app toggles for every preference under a kind
 * {@link /api/v1/notifications/preferences/kind/:kind_slug/}
 */
export async function updateAllNotificationPreferencesByKind(
  {
    kind_slug,
  }: {
    kind_slug: UpdateAllNotificationPreferencesByKindPathParams['kind_slug']
  },
  data?: UpdateAllNotificationPreferencesByKindMutationRequest,
  config: Partial<
    RequestConfig<UpdateAllNotificationPreferencesByKindMutationRequest>
  > & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateAllNotificationPreferencesByKindMutationResponse,
    ResponseErrorConfig<UpdateAllNotificationPreferencesByKind400>,
    UpdateAllNotificationPreferencesByKindMutationRequest
  >({
    method: 'PATCH',
    url: getUpdateAllNotificationPreferencesByKindUrl({
      kind_slug,
    }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
